<template>

    <video-player ref="videoPlayer"
                  id="thePlayer"
                  :options="playerOptions"
                  class="player-fit vjs-big-play-centered"
                  @play="onPlayerPlay($event)"
                  @ready="onPlayerReady($event)"
                  @ended="playbackFinished"
                  disablepictureinpicture>
    </video-player>

</template>

<script>

    import { videoPlayer } from 'vue-videojs7'

    export default {

        components: {
            videoPlayer
        },

        data () {

            return {

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY,
                ENV_Legacy_Thumbnails: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,

                playCountUpdated: false
            }
        },

        computed: {

            mediaSrc() {
                if(!this.$root.shared.isLegacyContent) {
                    return this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.storage_url;
                } else {
                    return this.ENV_CloudFront_Legacy_DNS_Name + this.$root.shared.playerPayload.storage_url;
                }
            },

            mediaType() {
                if(!this.$root.shared.isLegacyContent) {
                    return 'application/x-mpegURL'
                } else {
                    return 'video/mp4'
                }
            },

            playerOptions() {

                let posterURL = '';

                if (this.$root.shared.playerPayload.is_hero) {
                    if (this.$root.shared.isLegacyContent) {
                        posterURL = this.ENV_Legacy_Thumbnails + this.$root.shared.playerPayload.hero_thumbnail + '.jpg';
                    } else {
                        posterURL = this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.filename + '/' + this.ENV_Thumbnail_Key + this.$root.shared.playerPayload.hero_thumbnail + '.jpg';
                    }
                } else {
                    if (this.$root.shared.isLegacyContent) {
                        posterURL = this.ENV_Legacy_Thumbnails + this.$root.shared.playerPayload.thumbnail_url;
                    } else {
                        posterURL = this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.thumbnail_url;
                    }
                }

                return {
                    autoplay: false,
                    controls: true,
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                    },
                    fluid: true,
                    poster: posterURL,
                    sources: [ {
                        src: this.mediaSrc,
                        type: this.mediaType
                    }],
                }

            },

        },

        props: [
            'currentlocale'
        ],

        methods: {

            onPlayerPlay (player) {

                if(!this.playCountUpdated) {

                    // Let's update the play count for this Content; while we are here, let's check if
                    // the Content is in the Current User's Watch Later list, and if so, remove it.
                    // Also, log the view into the user's history, if authenticated

                    axios.get('/' + this.currentlocale + '/content/stats/add-play/' + this.$root.shared.playerPayload.id)
                        .then(response => {

                            this.playCountUpdated = true;
                            this.$root.shared.contentPlays = JSON.stringify(response.data);

                            // If there is an authenticated user... and...
                            // If the Content is in the Watch Later playlist, let's remove it from it;
                            // Then, log the
                            if (window.Laravel.user) {
                                // First, check watch later:
                                axios.get('/' + this.currentlocale + '/watchlater/removeif/' + this.$root.shared.playerPayload.id)
                                    .then((response) => {
                                        console.log('Watch Later playlist check done.')
                                    })
                                    .catch((error) => {
                                        console.log('ERROR while checking this user\'s Watch Later playlist: ' + error)
                                    })

                                // Then, log to history:
                                axios.post('/' + this.language + '/history', {
                                    'language': this.language,
                                    'userId': window.Laravel.user.id,
                                    'contentId': this.$root.shared.playerPayload.id
                                })
                                    .then((response) => {
                                        console.log('Successfully logged this view to the user\'s history.')
                                    })
                                    .catch((error) => {
                                        console.log('ERROR trying to log this content to the user\'s history: ' + error)
                                    })

                            }
                        })
                        .catch(error => {
                            console.log('There was an error updating the Play Count for this Content! ERROR: ' + error);
                        });

                    console.log('Updated the Content play count!');
                } else {
                    console.log('Play Count for this instance has already been updated, so skipping.');
                }
            },

            onPlayerReady (player) {
                console.log('player ready!', player)
                console.log('Media Duration: ', player.duration())
                if(this.$root.shared.autoplayIsEnabled) {
                    this.$refs.videoPlayer.player.play()
                }
            },

            playVideo: function (source) {

                if(this.$root.shared.isLegacyContent) {
                    const video = {
                        withCredentials: false,
                        type: 'video/mp4',
                        src: source
                    }

                    this.$refs.videoPlayer.player.src(video);
                    this.$refs.videoPlayer.player.controlBar.pictureInPictureToggle.dispose();

                } else {
                    const video = {
                        withCredentials: false,
                        type: 'application/x-mpegurl',
                        src: source,
                    }

                    this.$refs.videoPlayer.player.src(video);
                    this.$refs.videoPlayer.player.controlBar.pictureInPictureToggle.dispose();
                }
            },

            playbackFinished() {

                if(this.$root.shared.autoplayIsEnabled) {

                    //alert('Video has finished playing! Next up is: ' + this.$root.shared.comingUpContentCollection[0].title)
                    // Autoplay is enabled, so let's do this.
                    // FIRST: we need to know if there are items remaining to be played in the collection.
                    // What will happen is: we need to fetch the current item to play according to the autoplay item index.
                    // Once we increment this index in preparation for the next iteration, then we will set the player accordingly
                    // and initiate the playback, not before injecting the content item into the history state of the browser and
                    // setting the "currently playing content Id" so that it is available to general state

                    if(this.$root.shared.autoplayItemIndex < this.$root.shared.comingUpContentCollection.length) {
                        let itemToPlay = this.$root.shared.comingUpContentCollection[this.$root.shared.autoplayItemIndex]
                        this.$root.shared.autoplayItemIndex++
                        this.$root.shared.currentlyPlayingContentId = itemToPlay.id
                        window.history.pushState({"pageTitle": itemToPlay.title}, itemToPlay.title, '/' + this.currentlocale + '/content/' + itemToPlay.id)
                        Event.fire('showPlayer', {language: this.currentlocale, data: itemToPlay});
                        this.thisItemIsPlaying = true
                    }

                } else {

                    console.log('AutoPlay is DISABLED, so no further action will happen.')

                }

            }
        },

        mounted () {

            this.playVideo(this.mediaSrc)
        }

    }

</script>

<style scoped>

    .player {
        /* position: absolute !important; */
        width: 100%;
        height: 60%;
    }

    .vjs-custom-skin {
        height: 60% !important;
    }

    .vjs-custom-skin /deep/ .video-js {
        height: 60%;
    }

    .player-fit {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
    }

</style>
